import React from "react";
import {defaultSnackbarOptions} from "../../../../Config";
import {withSnackbar} from "react-simple-snackbar";
import Detail from "../MainType/Detail";
import {react_intl} from "../../../../index";

class Create extends Detail {
    title = react_intl.formatMessage({id:"admin.content.announcements.create.title"})
    thumbnail = false
    action = "create"
    content_type = "announcement"
    redirect_url = "/admin/announcements/:id"
    pageId = null
    back_url = "/admin/announcements"
    back_text =  react_intl.formatMessage({id:"admin.content.announcements.create.back_text"})
    save_button = react_intl.formatMessage({id:"admin.content.announcements.create.add"})
    post_loading = false
    canFeature = false
}

export default withSnackbar(Create, defaultSnackbarOptions)